import React, { useState, useEffect } from 'react';
import {
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  FormHelperText,
  Tooltip,
} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { lazyRep } from '../../services/CommonService';
import { ReactComponent as Info } from '../../assets/icons/info.svg';
import color from '../../assets/css/colors';

const useStyles = makeStyles(() => ({
  dropdownWrapper: {
    display: 'flex',
    position: 'relative',
  },
  tooltipWrapper: {
    position: 'absolute',
    top: 32,
    right: 8,
    padding: '9px 10px',
    backgroundColor: 'rgba(0,0,0,0)',
    borderRadius: 5,
    '& svg': {
      width: 21,
      height: 21,
      cursor: 'help',
      '& path': {
        fill: color.primary.main,
      }
    },
  },
  disabled: {
    color: 'rgba(0, 0, 0, 0.38)',
  },
}));

const HtmlTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: color.light.main,
    maxWidth: 620,
    border: '1px solid ' + color.light.light,
    borderRadius: 10,
  },
}))(Tooltip);

function SelectAutoCompleteRepAdvisor(props) {
  const classes = useStyles();
  const [items, setItems] = useState([]);

  const getRepAdvisorItems = async () => {
    const { repadvisorsList } = await lazyRep(props.correspondent);
    setItems(repadvisorsList);
  };

  useEffect(() => {
    if (props.correspondent) {
      getRepAdvisorItems(props.value);
    }
    // eslint-disable-next-line
  }, [props.correspondent]);

  return (
    <div className={classes.dropdownWrapper}>
      <FormControl
        fullWidth
        error={props.error}
        style={{
          marginTop: props.mt ? props.mt : 0,
          marginBottom: props.mb ? props.mb : 0,
        }}
      >
        <InputLabel
          className={props.disabled ? classes.disabled : ''}
          shrink
          required={props.required}
        >
          {props.label}
        </InputLabel>
        <Select
          displayEmpty
          fullWidth
          defaultValue=""
          disabled={props.disabled}
          name={props.name}
          value={props.value ? props.value : ''}
          onChange={props.onChange}
        >
          <MenuItem key="blank" value="" disabled={props.required}>
            Blank
          </MenuItem>
          {items.length ? (
            items.map((item, index) => (
              <MenuItem key={index} value={item?.repCode}>
                {`${item?.repCode} - ${item?.firstName} ${item?.lastName}`}
              </MenuItem>
            ))
          ) : (
            <MenuItem key="" value=""></MenuItem>
          )}
        </Select>
        {props.error && <FormHelperText>{props.error ? props.msg : ''}</FormHelperText>}
      </FormControl>
      {(props.tooltip || props.htmlTooltip) && (
        <div className={classes.tooltipWrapper}>
          {props.tooltip ? (
            <Tooltip arrow placement="top" title={props.tooltip}>
              <Info />
            </Tooltip>
          ) : (
            <HtmlTooltip
              placement="top"
              title={<React.Fragment>{props.htmlTooltip}</React.Fragment>}
            >
              <Info />
            </HtmlTooltip>
          )}
        </div>
      )}
    </div>
  );
}

export default SelectAutoCompleteRepAdvisor;
